// extracted by mini-css-extract-plugin
export default {"container":"TopGrossingTable_container__xddeF","rank-value":"TopGrossingTable_rank-value__IxdXy","rank-value--outside":"TopGrossingTable_rank-value--outside__8TQfM"};